import React from "react";
import About from "./About";
import CaseStudies from "./CaseStudies";
import ClarityCall from "./ClarityCall";
import Contact from "./Contact";
import FAQ from "./FAQ";
import Projects from "./Projects";
import Services from "./Services";
import Skills from "./Skills";
import SolutionPacks from "./SolutionPacks";
import { caseStudies } from "../data";
import Testimonials from "./Testimonial";
import WhoWeHelp from "./WhoWeHelp";

export default function Home() {
  return (
    <>
      <About />
      <Services />
      <SolutionPacks />
      <WhoWeHelp />
      <Projects />
      {caseStudies.length > 0 && <CaseStudies />}
      <Skills />
      <Testimonials />
      <ClarityCall />
      <FAQ />
      <Contact />
    </>
  );
}
